import { BaseService } from "./common/base";
import type { DispatchOperator } from "../../../../api/src/dispatch-operator/entities/dispatch-operator.entity";

export class DispatchOperatorService extends BaseService<DispatchOperator> {
  constructor() {
    super("dispatch-operator");
  }
}
